module.exports = __webpack_public_path__ + "static/img/13.22405ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/eng/13.png
// module id = j8tL
// module chunks = 0